import { useBreakpointValue } from '@genial/utils';
import React from 'react';

import { SentOrdersListResponseNormalized } from '../../../../../../store/rateManagement/selector';

import { SentOrderListItemDesktop } from './Desktop';
import { SentOrderListItemMobile } from './Mobile';

export declare namespace SentOrderListItemTypes {
  export interface Props {
    item: SentOrdersListResponseNormalized;
    loading?: boolean;
  }
}

export const SentOrderListItem: React.FC<SentOrderListItemTypes.Props> = ({ loading, item }) => {
  const content = useBreakpointValue({
    base: <SentOrderListItemMobile loading={loading} item={item} />,
    sm: <SentOrderListItemDesktop item={item} />,
  });

  return content;
};
